import { motion } from 'framer-motion';

export function BlobsBackground() {
  return (
    <div className="fixed inset-0 z-0">
      {/* Background Blobs */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Blob 1 - Top Left */}
        <motion.div
          animate={{
            borderRadius: [
              '60% 40% 30% 70% / 60% 30% 70% 40%',
              '30% 60% 70% 40% / 50% 60% 30% 60%',
            ],
            x: [0, 10, 0],
            y: [0, -15, 0],
          }}
          className="bg-primary/10 absolute left-10 top-20 size-64 mix-blend-multiply blur-xl"
          style={{ borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%' }}
          transition={{
            duration: 20,
            ease: 'easeInOut',
            repeat: Infinity,
            repeatType: 'reverse',
          }}
        />

        {/* Blob 2 - Top Right */}
        <motion.div
          animate={{
            borderRadius: [
              '40% 60% 70% 30% / 40% 50% 60% 50%',
              '60% 40% 30% 70% / 60% 40% 50% 40%',
            ],
            x: [0, -15, 0],
            y: [0, 20, 0],
          }}
          className="bg-secondary/10 absolute -right-20 top-[20%] size-64 mix-blend-multiply blur-xl sm:size-72 md:size-96 lg:-right-40 lg:size-[28rem]"
          style={{ borderRadius: '40% 60% 70% 30% / 40% 50% 60% 50%' }}
          transition={{
            duration: 25,
            ease: 'easeInOut',
            repeat: Infinity,
            repeatType: 'reverse',
          }}
        />

        {/* Blob 3 - Bottom Left */}
        <motion.div
          animate={{
            borderRadius: [
              '50% 50% 70% 30% / 30% 30% 70% 70%',
              '30% 70% 70% 30% / 30% 50% 50% 70%',
            ],
            x: [0, 15, 0],
            y: [0, -20, 0],
          }}
          className="bg-secondary/10 absolute bottom-32 left-20 size-64 mix-blend-multiply blur-xl sm:size-72 md:size-96 lg:size-[26rem]"
          style={{ borderRadius: '50% 50% 70% 30% / 30% 30% 70% 70%' }}
          transition={{
            duration: 22,
            ease: 'easeInOut',
            repeat: Infinity,
            repeatType: 'reverse',
          }}
        />

        {/* Blob 4 - Bottom Right */}
        <motion.div
          animate={{
            borderRadius: [
              '30% 70% 70% 30% / 30% 30% 70% 70%',
              '50% 30% 30% 70% / 60% 40% 60% 40%',
            ],
            x: [0, -10, 0],
            y: [0, 15, 0],
          }}
          className="bg-primary/10 absolute -bottom-40 -right-20 size-72 mix-blend-multiply blur-xl md:size-96 lg:-right-40 lg:size-[32rem]"
          style={{ borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%' }}
          transition={{
            duration: 28,
            ease: 'easeInOut',
            repeat: Infinity,
            repeatType: 'reverse',
          }}
        />

        {/* Blob 5 - Center */}
        <motion.div
          animate={{
            borderRadius: [
              '60% 40% 40% 60% / 40% 60% 40% 60%',
              '40% 60% 60% 40% / 60% 40% 60% 40%',
            ],
            scale: [1, 1.05, 1],
            y: [0, 10, 0],
          }}
          className="bg-primary/10 absolute left-1/3 top-1/3 hidden size-64 mix-blend-multiply blur-xl md:block md:size-80 lg:size-96"
          style={{ borderRadius: '60% 40% 40% 60% / 40% 60% 40% 60%' }}
          transition={{
            duration: 30,
            ease: 'easeInOut',
            repeat: Infinity,
            repeatType: 'reverse',
          }}
        />
      </div>
    </div>
  );
}
